<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid mb-5">
          <div class="field">
            <label class="font-medium required-field">Код подтверждения</label>
            <crm-input-text
              [(value)]="card.code"
              [isError]="$any(errors?.code)"></crm-input-text>
            <small
              *ngIf="errors?.code"
              class="p-error">
              {{ errors.code | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип</label>
            <p-selectButton
              [options]="accessCardTypeOptions"
              [(ngModel)]="card.type"
              optionLabel="label"
              optionValue="value"></p-selectButton>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Срок действия</label>
            <crm-daterangepicker
              [value]="[card.begin, card.end]"
              (changeValue)="setDate($event)"
              [showClear]="true"
              appendTo="body"></crm-daterangepicker>
          </div>

          <!--          <div class="field">-->
          <!--            <label class="font-medium">Макс. кол-во использований</label>-->
          <!--            <p-inputNumber-->
          <!--              [(ngModel)]="card.maxPasses"-->
          <!--              class="w-full {{ errors?.maxPasses ? 'ng-invalid ng-dirty' : '' }}"-->
          <!--              styleClass="w-full {{ errors?.maxPasses ? 'ng-invalid ng-dirty' : '' }}"-->
          <!--              [min]="0"></p-inputNumber>-->
          <!--            <small-->
          <!--              *ngIf="errors?.maxPasses"-->
          <!--              class="p-error">-->
          <!--              {{ errors.maxPasses | join }}-->
          <!--            </small>-->
          <!--          </div>-->

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="card.isActive"
              [binary]="true"
              [disabled]="(settings$ | async)?.blocked"
              inputId="isActive"></p-checkbox>
            <label [for]="'isActive'">Карта активна</label>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="card.isBlocking"
              [binary]="true"
              inputId="isBlocking"></p-checkbox>
            <label [for]="'isBlocking'">Блокирующая карта</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveCard()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteCard()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
